// open values of an imported network: fields the source did not deliver, still empty, with a suggestion in obj.sug
const num = (v) => (v == null || v === '' || !Number.isFinite(+String(v).replace(',', '.')) ? null : +String(v).replace(',', '.'));
const openK = (o, k) => (k === 'd' ? !(num(o.hyd?.d) || /\d{2,4}/.test(String(o.dn || ''))) : k === 'year' ? !num(o.hyd?.year) : k === 'rim' ? num(o.elev?.v) == null : k === 'inv' ? num(o.hyd?.inv) == null && num(o.sw?.depth) == null : false);

export function gapsOf(project) {
  const c = { d: 0, year: 0, rim: 0, inv: 0 };
  [...(project?.fittings || []), ...(project?.pipes || [])].forEach((o) => o.sug && Object.keys(o.sug).forEach((k) => { if (k in c && openK(o, k)) c[k]++; }));
  return { n: c.d + c.rim + c.inv, c };
}

// user confirmed: take the suggestions for the still empty fields, mark them as assumption
export const fillGaps = (pr) => ({
  ...pr,
  fittings: (pr.fittings || []).map((f) => {
    if (!f.sug) return f;
    const g = { ...f, hyd: { ...(f.hyd || {}) } }, done = [];
    if (openK(f, 'rim') && f.sug.rim != null) { g.elev = { v: f.sug.rim, src: 'assumed' }; done.push('Deckel'); }
    if (openK(f, 'inv') && f.sug.inv != null) { g.hyd.inv = f.sug.inv; done.push('Sohle'); }
    if (num(g.elev?.v) != null && num(g.hyd.inv) != null) g.depth = +(num(g.elev.v) - num(g.hyd.inv)).toFixed(2);
    delete g.sug;
    return done.length ? { ...g, assumed: done, note: `Annahme (Import-Vorschlag bestätigt): ${done.join(', ')}` } : g;
  }),
  pipes: (pr.pipes || []).map((p) => {
    if (!p.sug) return p;
    const g = { ...p, hyd: { ...(p.hyd || {}) } }, done = [];
    if (openK(p, 'd') && p.sug.d) { g.dn = `DN ${p.sug.d}`; g.hyd.d = p.sug.d; done.push(`DN ${p.sug.d}`); }
    delete g.sug;
    return done.length ? { ...g, assumed: done, note: `Annahme (Import-Vorschlag bestätigt): ${done.join(', ')}` } : g;
  }),
});
